export const BATHROOM_PATH = '/uslugi/proektirovanie-i-dizayn/sozdayte-vannuyu-komnatu-svoey-mechty/';

export const BATHROOM_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,d_photoiscoming.png,b_auto/fudzi/elbrus/images/landings/bathrooms-2';

export const BATHROOM_LANDING_NAME = 'bathroom';

export const BATHROOM_ELEMENT_BLOCK = 'landingVannuyuKomnatu';

export const CATEGORY_ID = '934';
